import { supabase } from "../supabaseClient"

const invokeGoogleAdsManager = async (body) => {
  const { data, error } = await supabase.functions.invoke("google-ads-manager", { body })
  if (error) {
    let payload = null
    if (error.context?.json) {
      try { payload = await error.context.json() } catch (_) {
        // Preserve the function client's error.
      }
    }
    const requestError = new Error(
      payload?.error || error.message || "Google Ads request failed",
    )
    requestError.code = payload?.code || null
    requestError.details = payload?.details || null
    requestError.requestId = payload?.request_id || null
    throw requestError
  }
  if (data?.error) {
    const requestError = new Error(data.error)
    requestError.code = data.code || null
    requestError.details = data.details || null
    requestError.requestId = data.request_id || null
    throw requestError
  }
  return data || {}
}

export const startGoogleAdsOAuth = (organizationId) =>
  invokeGoogleAdsManager({ action: "oauth-start", organization_id: organizationId })

export const completeGoogleAdsOAuth = (organizationId, code, state) =>
  invokeGoogleAdsManager({
    action: "oauth-complete",
    organization_id: organizationId,
    code,
    state,
  })

export const listGoogleAdsConnections = (organizationId) =>
  invokeGoogleAdsManager({ action: "list-connections", organization_id: organizationId })

export const listGoogleAdsCustomers = (organizationId, oauthConnectionId) =>
  invokeGoogleAdsManager({
    action: "list-customers",
    organization_id: organizationId,
    oauth_connection_id: oauthConnectionId,
  })

export const saveGoogleAdsCustomer = (
  organizationId,
  oauthConnectionId,
  customerId,
) => invokeGoogleAdsManager({
  action: "save-customer",
  organization_id: organizationId,
  oauth_connection_id: oauthConnectionId,
  customer_id: customerId,
})

export const listGoogleAdsConversionActions = (organizationId, customerConnectionId) =>
  invokeGoogleAdsManager({
    action: "list-conversion-actions",
    organization_id: organizationId,
    customer_connection_id: customerConnectionId,
  })
